import { Motif } from '@/store/motifs/Motif';

export class Motifs {
	listeMotifs: Motif[];

	constructor(value: { listeMotifs: Motif[] }) {
		this.listeMotifs = value.listeMotifs;
	}
}
